import { sessionPrefix } from "./helpers";

export const adminPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/admin`;
